module.exports = __webpack_public_path__ + "img/resource-zn-active.885fbc83.png";